export default {
  DIARRHEA: 'diarrhea', // ท้องเสีย
  VOMIT: 'vomit', // อาเจียน
  CONSTIPATION: 'constipation' // ท้องผูก
}
